import { Component, OnInit } from '@angular/core';

import { AssetUnitPipe, SubscriberComponent } from 'common';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import {
  RebalancingRepository,
  RebalancingState,
} from '../../../../repository';
import { NgIcon } from '@ng-icons/core';
import { timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RebalancingStep } from '../../rebalancing-step.enum';

@Component({
  selector: 'common-rebalancing-order-details-expirations',
  standalone: true,
  imports: [CommonModule, TranslateModule, AssetUnitPipe, NgIcon],
  templateUrl: './expirations.component.html',
  styleUrls: ['./expirations.component.scss'],
})
export class ExpirationsComponent
  extends SubscriberComponent
  implements OnInit
{
  public rebalancingSteps = RebalancingStep;

  public initialExpirationMilliseconds = 0;
  public expirationMilliseconds = 0;
  public refreshMilliseconds = 0;

  constructor(private rebalancingRepository: RebalancingRepository) {
    super();
  }

  ngOnInit(): void {
    timer(0, 1000)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        if (
          !this.store.rebalancing?.expirationTimestamp ||
          this.store.rebalancing.isExpired()
        ) {
          return;
        }

        const millisecondsTillExpired =
          this.store.rebalancing.expirationTimestamp.getTime() -
          new Date().getTime();

        // set initialExpirationMilliseconds required for countdown animation
        if (this.store.rebalancing?.creationDate) {
          this.initialExpirationMilliseconds =
            this.store.rebalancing.expirationTimestamp.getTime() -
            this.store.rebalancing.creationDate.getTime();
        } else {
          if (!this.initialExpirationMilliseconds) {
            this.initialExpirationMilliseconds = millisecondsTillExpired;
          }
        }

        if (millisecondsTillExpired > 0) {
          this.expirationMilliseconds = millisecondsTillExpired;
        } else {
          this.expirationMilliseconds = 0;
        }

        if (!this.store.rebalancing?.suggestedRefreshQuotesTimestamp) {
          return;
        }

        const millisecondsTillRefresh =
          this.store.rebalancing.suggestedRefreshQuotesTimestamp.getTime() -
          new Date().getTime();

        if (millisecondsTillRefresh > 0) {
          this.refreshMilliseconds = millisecondsTillRefresh;
        } else {
          this.refreshMilliseconds = 0;
        }
      });
  }

  public get store(): RebalancingState {
    return this.rebalancingRepository.store.getValue();
  }

  public getExpirationPercentage(): number {
    if (!this.expirationMilliseconds) {
      return 0;
    }

    return (
      (this.expirationMilliseconds / this.initialExpirationMilliseconds) * 100
    );
  }
}
